import { formatDate } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CHAT_BOT_ASESOR_V2_TOOLTIP } from '../../../constants/chat-bot-asesor-v2.constant';
import { IChatBotV2MensajeDocumento } from '../../../models/chat-bot-v2.model';
import { AlertService } from '../../../services/alert/alert.service';
import { ChatBotV2DataService } from '../../../services/chat-bot-v2/chat-bot-v2.data.service';
import { ChatBotV2Service } from '../../../services/chat-bot-v2/chat-bot-v2.service';
import { ChatBotAsesorV2UploadComponent } from '../chat-bot-asesor-v2-upload/chat-bot-asesor-v2-upload.component';

@Component({
  selector: 'app-chat-bot-asesor-v2-chat',
  templateUrl: './chat-bot-asesor-v2-chat.component.html',
})
export class ChatBotAsesorV2ChatComponent {

  @ViewChild('formEl') formEl: ElementRef<HTMLFormElement>;
  @ViewChild('textareaEl') textarea: ElementRef<HTMLTextAreaElement>;

  mensajeDisclaimer = "Información no siempre precisa. Verificar respuestas";
  enviandoMsg: boolean;

  textoTooltip = CHAT_BOT_ASESOR_V2_TOOLTIP;

  constructor(
    public chatBotV2DS: ChatBotV2DataService,
    public chatBotV2S: ChatBotV2Service,
    private dialog: MatDialog,
    private alertS: AlertService
  ) { }

  onSubmit() {
    this.enviarMsg();
  }

  async enviarMsg() {
    this.enviandoMsg = true;
    let { pregunta } = this.chatBotV2DS.chatForm.value;
    const docs: IChatBotV2MensajeDocumento[] = this.chatBotV2DS.chatForm.value?.documentos || [];
    const arrayDocStr: string[] = docs.map((_, index) => `{document.${index}}`);
    const docStr: string = arrayDocStr.join(' ');
    pregunta = `${pregunta || ''} ${docStr}`;


    this.chatBotV2DS.historialChat.push({
      tipoMensaje: 'SALIENTE',
      contenidoMensaje: pregunta,
      fechaMensaje: `Pregunta realizada el ${formatDate(new Date(), 'DD/MM/YYYY HH:mm:ss', 'es-CL')}`,
      regenerable: true,
      question: pregunta,
      documentos: docs,
    });

    this.chatBotV2DS.historialChat.push({
      tipoMensaje: 'ENTRANTE',
      contenidoMensaje: '',
      loading: true
    });

    try {

      await this.checkSession();

      const config = this.chatBotV2DS.obtenerConfiguracionPregunta();

      const mensajeEntrante = await this.chatBotV2S.enviarMensaje(pregunta, config, docs);

      this.chatBotV2DS.historialChat.pop();

      this.chatBotV2DS.historialChat.push({
        tipoMensaje: 'ENTRANTE',
        idMensaje: mensajeEntrante.data.idMensaje,
        contenidoMensaje: mensajeEntrante.data.respuesta,
        fechaMensaje: `Respuesta actualizada el  ${formatDate(new Date(), 'DD/MM/YYYY HH:mm:ss', 'es-CL')}`,
        question: mensajeEntrante.data.pregunta,
        topic: mensajeEntrante.data.topic,
        disclaimer: this.mensajeDisclaimer,
      });
    } catch (error) {
      this.chatBotV2DS.historialChat.pop();
      this.alertS.showSnackBarTopRight({
        titulo: 'Error:',
        mensaje: 'Ocurrio un problema al enviar el mensaje!',
        severity: 'error',
        enFila: true
      });
    } finally {
      this.enviandoMsg = false;
      setTimeout(() => this.formEl.nativeElement.scrollIntoView({ behavior: 'smooth' }));
    }

  }

  private async checkSession() {
    if (!this.chatBotV2DS.sessionID) {
      const session = await this.chatBotV2S.crearSesion();
      this.chatBotV2DS.sessionID = session.data.data.sessionId;
    }
  }

  keyDown(event: KeyboardEvent) {
    if (event.key !== 'Enter') return;
    event.preventDefault();
    if (this.enviandoMsg) return;
    this.onSubmit();
    this.chatBotV2DS.chatForm.reset();
  }

  subirDocumentos() {
    if (this.chatBotV2DS.chatForm.value?.documentos?.length >= this.chatBotV2DS.maxFiles) return;
    const dialogRef = this.dialog.open(ChatBotAsesorV2UploadComponent, {
      disableClose: true,
      hasBackdrop: true,
      autoFocus: false,
      maxWidth: '600px',
      panelClass: 'sura'
    });
  }

  dragFiles(_files: FileList) {
    const files = Array.from(_files);
    this.chatBotV2DS.agregarFiles(files);
  }

  /**
   * LOG nuevo chat
   * 
    const logNuevoChat: IDatosAdicionales = {
        accion: LOG_CHATBOT.REINICIO_CHATBOT,
        glosa: LOG_CHATBOT.REINICIO_CHATBOT_GLOSA,
        metodo: 'LOG',
        payload: { MENSAJE: 'EL USUARIO CREA UN NUEVO HILO DE CONVERSACION.' },
        stash: 'log_negocio',
        tipoLog: 'NEGOCIO',
        salida: '-',
        estado: 'OK',
    }
   */

}
